import { Bell, Menu, ShoppingCart, User, X } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import "../../../assets/css/customer/navigationbar/MyNavbar.css";
import Logo from "../../../assets/images/AD Furniture House.png";
import Login from "../auth/Login";
import Signup from "../auth/Signup";
import AppContext from "../../../context/AppContext";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const MyNavbar = () => {
  const {
    baseUrl,
    loggedInCustomer,
    setLoggedInCustomer,
    authToken,
    setAuthToken,
    setCartCount,
    cartCount,
    notificationCount,
    fetchNotificationCount,
  } = useContext(AppContext);
  const [scrolled, setScrolled] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(authToken);

    //get cart count
    getCartCount();

    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);

    if (loggedInCustomer && authToken) {
      fetchNotificationCount();
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [authToken, loggedInCustomer]);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  // get cart count
  const getCartCount = () => {
    const formData = new FormData();
    formData.append("adcustomer_id", loggedInCustomer?.id);
    axios
      .post(`${baseUrl}/customer/cart/getCartCount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        setCartCount(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  const openDecorAI = () => {
    setMobileMenuOpen(false);
    navigate("/decora-ai");
  };

  return (
    <>
      {/* ── TOPBAR ─────────────────────── */}
      <div className={`mn-topbar ${scrolled ? "mn-topbar-hidden" : ""}`}>
        <div className="mn-topbar-container">
          {/* ── NOTIFICATION ICON — sirf logged-in customer ko dikhega ── */}
          {loggedInCustomer != null && (
            <Link
              to="/customer/notifications"
              className="mn-topbar-icon mn-notification-icon"
              aria-label="Notifications"
            >
              <Bell size={20} />
              {notificationCount > 0 && (
                <span className="mn-cart-badge">{notificationCount}</span>
              )}
            </Link>
          )}

          <a
            href="/cart"
            className="mn-topbar-icon mn-cart-icon"
            aria-label="Cart"
          >
            <ShoppingCart size={20} />
            {cartCount > 0 && (
              <span className="mn-cart-badge">{cartCount}</span>
            )}
          </a>

          {loggedInCustomer != null ? (
            <Link
              to={"/customer/dashboard"}
              className="mn-topbar-icon"
              aria-label="Profile"
            >
              <User size={20} />
            </Link>
          ) : (
            <button onClick={() => setShowLogin(true)} className="mn-login-btn">
              Login
            </button>
          )}
        </div>
      </div>

      {/* ── NAVBAR ───────────────────────────────────────── */}
      <nav className={`mn-navbar ${scrolled ? "mn-scrolled" : ""}`}>
        <div className="mn-navbar-container">
          <div className="mn-logo">
            <img className="mn-logo-image" src={Logo} alt="AD Furniture Logo" />
          </div>

          <div className={`mn-nav-menu ${mobileMenuOpen ? "active" : ""}`}>
            <button
              className="mn-drawer-close"
              onClick={() => setMobileMenuOpen(false)}
            >
              <X size={22} />
            </button>

            <a href="/" className="mn-nav-link" onClick={handleLinkClick}>
              HOME
            </a>

            <a
              href="/products"
              className="mn-nav-link"
              onClick={handleLinkClick}
            >
              PRODUCTS
            </a>
            <a
              href="/browse-bidding"
              className="mn-nav-link"
              onClick={handleLinkClick}
            >
              ACTIVE BIDS
            </a>

            {/* ── DECORA AI BUTTON — desktop navbar ── */}
            <button
              className="mn-decora-btn mn-decora-btn--desktop"
              onClick={openDecorAI}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 22V12h6v10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Decora AI
            </button>

            <a
              href="/our-story"
              className="mn-nav-link"
              onClick={handleLinkClick}
            >
              ABOUT US
            </a>
            <a
              href="/contact-us"
              className="mn-nav-link"
              onClick={handleLinkClick}
            >
              CONTACT US
            </a>

            {/* ── DECORA AI BUTTON — mobile drawer ── */}
            <button
              className="mn-decora-btn mn-decora-btn--mobile"
              onClick={openDecorAI}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 22V12h6v10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Decora AI
            </button>
          </div>

          <button
            className="mn-mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <Menu size={26} />
          </button>
        </div>

        <div
          className={`mn-menu-backdrop ${mobileMenuOpen ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        />
      </nav>

      {showLogin && (
        <Login
          onClose={() => setShowLogin(false)}
          onSwitchToSignup={() => {
            setShowLogin(false);
            setShowSignup(true);
          }}
        />
      )}
      {showSignup && (
        <Signup
          onClose={() => setShowSignup(false)}
          onSwitchToLogin={() => {
            setShowSignup(false);
            setShowLogin(true);
          }}
        />
      )}
    </>
  );
};

export default MyNavbar;
